/**
 * Helper para compartir contenido vía WhatsApp usando wa.me.
 *
 * wa.me/?text=... abre WhatsApp (web o app) con el texto pre-armado, y
 * el usuario elige el destinatario manualmente. No requiere API ni
 * autenticación — totalmente cero costo.
 *
 * Para volumen alto, considerar migrar a WhatsApp Cloud API (Meta) que
 * tiene 1000 conversaciones/mes free.
 */

export function buildWhatsappLink(text: string): string {
  return `https://wa.me/?text=${encodeURIComponent(text)}`
}

export function buildSignatureShareMessage(verificationUrl: string): string {
  return `Te comparto un documento firmado con SignWiz: ${verificationUrl}\n\nPodés verificar la firma escaneando el QR o abriendo el link.`
}
